<template>
  <div v-if="store.loginVisible">
    <FullScreenSpinner />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useAccountStore } from '@/store/account/account.state';
import { useRouter, useRoute } from 'vue-router';
import FullScreenSpinner from '@/components/FullScreenSpinner/FullScreenSpinner.vue';

/** Local state and data properties*/
const store = useAccountStore();

/** Computed Properties */

/** Functions */

/** Lifecycle Hooks */

onMounted(async () => {
  const route = useRoute();
  const router = useRouter();
  await router.isReady();
  store.authenticate(route.fullPath, false, true);
});
</script>
